/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SuiviFichierDto
 */
export interface SuiviFichierDto {
    /**
     * 
     * @type {number}
     * @memberof SuiviFichierDto
     */
    idsuiviFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof SuiviFichierDto
     */
    idsuivi?: number;
    /**
     * 
     * @type {number}
     * @memberof SuiviFichierDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof SuiviFichierDto
     */
    idtypeSuiviFichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviFichierDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the SuiviFichierDto interface.
 */
export function instanceOfSuiviFichierDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SuiviFichierDtoFromJSON(json: any): SuiviFichierDto {
    return SuiviFichierDtoFromJSONTyped(json, false);
}

export function SuiviFichierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuiviFichierDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsuiviFichier': !exists(json, 'idsuiviFichier') ? undefined : json['idsuiviFichier'],
        'idsuivi': !exists(json, 'idsuivi') ? undefined : json['idsuivi'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeSuiviFichier': !exists(json, 'idtypeSuiviFichier') ? undefined : json['idtypeSuiviFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function SuiviFichierDtoToJSON(value?: SuiviFichierDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsuiviFichier': value.idsuiviFichier,
        'idsuivi': value.idsuivi,
        'idfichier': value.idfichier,
        'idtypeSuiviFichier': value.idtypeSuiviFichier,
        'fileName': value.fileName,
    };
}

